<template>
    <div>
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <section class="sell_your_device_dashboard_default text-center" style="min-height:80vh">
            <div class="container-fluid">
                <div class="service_top_section__img_section text-center" :style="{'width':'100%'}">
                    <div class="row">
                        <Sidebar></Sidebar>
                        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 mb-4 cat-block-device">
                            <div class="container-fluid">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-3"></div>
                                        <div class="col-lg-4 col-md-6 user-profile-form">
                                            <h5>Your Profile Info</h5>
                                            <form class="form" role="form">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" name="user_name" :value="data.name" readonly id="user_name" placeholder="Username"/>
                                                </div>
                                                <div class="form-group">
                                                    <input type="text" class="form-control" name="user_email" :value="data.email" readonly id="user_email" placeholder="Email"/>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="col-lg-4 col-md-3"></div>
                                    </div>
                                </div>
                            </div>     
                        </div>
                    </div>
                </div>
            </div>
        </section>    
    </div>
</template>
<style src="./css/common.css"></style>
<script>
    import Loading from "vue-loading-overlay";
    import Sidebar from "../layout/Sidebar.vue";
    import {authHeader} from "../../auth";

    export default {
        name: "UserProfile",
        components: {
            Sidebar,
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                loader: "bars",
                data: [],
            }
        },
        created() {
            document.title = 'Geek Buy Back - Profile';
            this.getProfileData(); 
        },
        methods:{
            getProfileData: function() {
                this.isLoading = true;
                var config = {
                    method: "GET",
                    url: this.$api + this.$config.dashboard.userProfileURL,
                    headers: authHeader()
                };
                this.$axios(config).then(response => {
                    if(response.data.status == "success") {
                        this.data = response.data.user;
                        this.isLoading = false;
                    }
                }).catch(error => {
                    console.log(error);
                    this.isLoading = false;
                    this.$swal.fire({
                        icon: "error",
                        text: "Something went wrong. Please try again!"
                    });
                });      
            },
        }
    }
</script>